// extracted by mini-css-extract-plugin
export default {"icon":"FavoriteIcon_icon__qCgL+"};